{
  document.querySelectorAll(".js-installment-wrapper").forEach(wrapper => {
    setTimeout(() => {
      let wrapperTask = wrapper.querySelector("shopify-payment-terms")?.shadowRoot
      console.log(wrapperTask,"===>")
      const container = wrapperTask?.querySelector("#shopify-installments");
      const amountSpan = container?.querySelector("span.font-bold");
      
      if (container && amountSpan) {
        container.textContent = amountSpan.textContent; // Show only the price
      }
    }, 1000);
    });
}

// Fancybox.bind('[data-fancybox]', {}); 

class ImageModal extends HTMLElement {
    constructor() {
        super();
        const blockId = this.getAttribute('data-block-id');
        const openButtons = document.querySelectorAll(`.multicolumn-image-modal[data-block-id="${blockId}"]`);
        const closeButton = this.querySelector('.modal-close-button');
        const modalContainer = this.querySelector('.image-modal-main');
        const overlayContainer = this.querySelector('.modal-overlay');

        openButtons?.forEach(button => {
            button.addEventListener('click', () => {
                document.querySelectorAll('.image-modal-main.open').forEach(openModal => {
                    openModal.classList.remove('open');
                });
                modalContainer.classList.add('open');
                overlayContainer.style.display = 'block';
            });
        });
        closeButton?.addEventListener('click', () => {
            modalContainer.classList.remove('open');
            overlayContainer.style.display = 'none';
        });
        overlayContainer?.addEventListener('click', () => {
            modalContainer.classList.remove('open');
            overlayContainer.style.display = 'none';
        });
    }
}

customElements.define('image-modal', ImageModal);

// class Video extends HTMLElement {
//     constructor() {
//         super();
//     }
// }

// customElements.define('video', Video);


// B2b after login redirection 
{
  let b2bLoginLink = document.querySelectorAll('.js-b2b-login-link');

  if (b2bLoginLink.length > 0) {
    b2bLoginLink.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        let pathName = window.location.href;
        sessionStorage.setItem('b2bLoginPath', pathName);

        window.location.href = link.href;
      });
    });
  }

  if (window.location.href.includes('accountnumber')) {
    let redirectLocation = sessionStorage.getItem('b2bLoginPath');
    console.log(redirectLocation,"redirectLocation")
    
    if (redirectLocation) {
      sessionStorage.removeItem('b2bLoginPath');
      window.location.href = redirectLocation;
    }
  }
}


  // Dynamically load JSZip // zip dowloded image-gallery page
{
  if (!document.querySelector('.js-video-wrapper')){
    async function loadJSZip() {
      if (window.JSZip) return window.JSZip; // Avoid reloading if already loaded
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
        script.onload = () => resolve(window.JSZip);
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    const downloadBtn = document.querySelector(".dawonload_btn button");
    if (downloadBtn) {
      downloadBtn.addEventListener("click", async function () {
        const JSZip = await loadJSZip(); // Ensure JSZip is loaded
    
        const selectedImages = [];
        
        // Find selected checkboxes
        document.querySelectorAll(".product_dls input:checked").forEach((checkbox) => {
          // Get the image associated with this checkbox
          const imageContainer = checkbox?.closest(".tab_gallery_item")?.querySelector("img");
          const imageName = checkbox?.closest(".tab_gallery_item")?.querySelector(".js-tab-item-title")?.textContent;
          if (imageContainer) {
            selectedImages.push({ url: imageContainer.src, name: imageName });
          }
        });
    
        if (selectedImages.length === 0) {
          alert("Please select at least one image.");
          return;
        }
    
        const zip = new JSZip();
    
        // Download and add images to ZIP
        const imagePromises = selectedImages.map(async ({ url, name }) => {
          let imgName = null;
          const response = await fetch(url);
          const blob = await response.blob();
          const urlParts = url.split("/");
          let fileName = urlParts[urlParts.length - 1];
          if (name != null) {
            imgName = sanitizeFileName(name) + ".jpg"
          } else {
            imgName = fileName.split("?")[0];
          }

          zip.file(imgName, blob);
        });
    
        await Promise.all(imagePromises);
    
        // Generate ZIP and trigger download
        zip.generateAsync({ type: "blob" }).then((content) => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(content);
          a.download = "selected-images.zip";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      }); 
      function sanitizeFileName(name) {
        return name.replace(/[\\/:*?"<>|]/g, ""); // replace invalid chars with underscore
      }
    }
  }
}

{
  function hideThenShow(img) {
    img.style.display = 'none'; 
    setTimeout(() => {
      img.style.display = 'block'; 
    }, 1000); 
  }
}

// product list

setTimeout(() => {
  const sliderElement = document.querySelectorAll('.js-swiper-product-carousel-new');
  
  sliderElement.forEach(function (slide) {
    if (slide) {
      new Swiper(slide, {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      });
    }
  })
  
  updateAllImageHeights();
},1100);

{
  const accordionItems = document.querySelectorAll(".js-product-accordion-item");
  accordionItems.forEach((item) => {
    const header = item?.querySelector(".js-product-accordion-item-header");
    if (header) {
      header.addEventListener("click", () => {
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("open");
          }
        });
        item.classList.toggle("open");
      });
    }
  });
}

{
  let filterButton = document.querySelector('.facets__button-show');
  let filterTabs = document.querySelectorAll('.js-filter-tab');
  let filterDetails = document.querySelectorAll('details.js-filter');
  if (filterButton && filterTabs && filterDetails) {
    filterTabs.forEach((tab)=>{
      tab.addEventListener('click', function(){
        filterButton.click();
        filterDetails.forEach((detail)=>{
          let tabContent = tab.textContent.toLowerCase();
          let detailContent = detail.querySelector('summary').textContent.toLowerCase().trim();
          if (detailContent != tabContent){
            detail.removeAttribute('open');
          } else {
            detail.setAttribute('open', 'open');
          }
        })
      })
    })
  }
}
// PDP image list height
{
  // function updateImageHeight() {
  //   let productImageList = document.querySelector('.js-media-list');
  //   let productImageWrapper = document.querySelector('.js-media-wrapper');
  //   if (productImageList) {
  //     let wrapperHeight = productImageList.offsetHeight;
  //     productImageWrapper.style.setProperty('--pdp-image-height', `${wrapperHeight}px`);
  //   }
  // }

  // updateImageHeight();
  // window.addEventListener('resize', ()=> {
  //   updateImageHeight();
  // });
  function updateAllImageHeights() {
    const wrappers = document.querySelectorAll('.js-media-wrapper');

    wrappers.forEach(wrapper => {
      const mediaList = wrapper.querySelector('.js-media-list');
      if (mediaList) {
        const height = mediaList.offsetHeight;
        wrapper.style.setProperty('--pdp-image-height', `${height}px`);
      }
    });
  }
  updateAllImageHeights();
  window.addEventListener('resize', updateAllImageHeights);
}

/* Filter Tabs JS Logic */
document.addEventListener('DOMContentLoaded', () => {
  const tabIcons = document.querySelectorAll('.js-tabs-content');
  const tabContents = document.querySelectorAll('.js-tabs-inner');

  if (tabIcons.length > 0 && tabContents.length > 0) {
    tabIcons.forEach((icon, index) => {
      icon.addEventListener('click', () => {
        tabIcons.forEach(i => i.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        icon.classList.add('active');
        tabContents[index]?.classList.add('active');
      });
    });
  }
});

/* Mobile Filter Drawer JS */
{
  const tabsButton = document.querySelector('.mobile-filter-button');
  if (tabsButton){
    tabsButton.addEventListener('click', () => {
      const tabMainContent = document.querySelector('.facets-modal__content-wrapper');
      const tabsFilter = tabMainContent.querySelectorAll('.js-filter');
      tabsFilter.forEach((icon, index) => {
        if(!icon.classList.contains('filter-label-color')){
          icon.removeAttribute('open');
        }
      });
    });
  }
}

// Icon hover effect
{
  const options = document.querySelectorAll('.js-icon-hover');

  if (options.length > 0) {
    options.forEach(option => {
      const tooltip = option.closest('.product__sku')?.querySelector('.product-toolbar-wrapper');
      const tooltipText = tooltip?.querySelector('.product-toolbar-text');

      if (tooltip && tooltipText.textContent.trim() !== '') {
        const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed

        if (isMobile) {
          option.addEventListener('click', () => {
            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';
          });
        } else {
          // Desktop: show on hover
          option.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          option.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      }
    });
  }
}

{
  document.addEventListener('change', function(event) {
    if (window.innerWidth > 767) return;
    const select = event.target.closest('.js-sync-select');
    if (!select) return;

    const selectedValue = select.value;

    const selects = document.querySelectorAll('.js-sync-select');

    selects.forEach(otherSelect => {
      if (otherSelect !== select) {
        otherSelect.value = selectedValue;
        const matchingOption = otherSelect.querySelector(`option[value="${selectedValue}"]`);
        if (matchingOption) {
          matchingOption.click();
        }
      }
    });
  });
}

// popup

document.addEventListener('DOMContentLoaded', function() {
	const videoTriggers = document.querySelectorAll('.video-popup-trigger');
	const videoOverlay = document.getElementById('videoPopupOverlay');
	const videoContainer = document.getElementById('videoContainer');
	const closeButton = document.getElementById('videoPopupClose');

	// Function to extract video ID from YouTube URL
	function getYouTubeVideoId(url) {
		const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
		const match = url.match(regExp);
		return (match && match[2].length === 11) ? match[2] : null;
	}

	// Function to extract video ID from Vimeo URL
	function getVimeoVideoId(url) {
		const regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
		const match = url.match(regExp);
		return match ? match[1] : null;
	}

	// Function to create video iframe
	function createVideoIframe(url) {
		let embedUrl = '';
		
		if (url.includes('youtube.com') || url.includes('youtu.be')) {
			const videoId = getYouTubeVideoId(url);
			if (videoId) {
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
			}
		} else if (url.includes('vimeo.com')) {
			const videoId = getVimeoVideoId(url);
			if (videoId) {
				embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
			}
		} else {
			// For direct video files
			return `<video controls autoplay style="width: 100%; height: 100%; fullscreen; loop; infinite; allowfullscreen;"><source src="${url}" type="video/mp4">Your browser does not support the video tag.</video>`;
		}

		if (embedUrl) {
			return `<iframe src="${embedUrl}" width="100%" height="100%" loop; frameborder="0" infinite; allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
		}
		
		return '<p style="color: white; text-align: center; padding: 20px;">Invalid video URL</p>';
	}

	// Open video popup
	videoTriggers.forEach(trigger => {
		trigger.addEventListener('click', function(e) {
			e.preventDefault(); 
			e.stopPropagation();
			
			const videoUrl = this.getAttribute('data-video-url');
			if (videoUrl) {
				videoContainer.innerHTML = createVideoIframe(videoUrl);
				videoOverlay.classList.add('active');
				document.body.style.overflow = 'hidden';
			}
		});
	});

	// Close video popup
	function closeVideoPopup() {
		videoOverlay.classList.remove('active');
		videoContainer.innerHTML = '';
		document.body.style.overflow = '';
	}

	closeButton?.addEventListener('click', closeVideoPopup);

	// Close on overlay click
	videoOverlay?.addEventListener('click', function(e) {
		if (e.target === videoOverlay) {
			closeVideoPopup();
		}
	});

	// Close on escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && videoOverlay.classList.contains('active')) {
			closeVideoPopup();
		}
	});
});

// Clear Active Facets Filter Values
{
  document.addEventListener('DOMContentLoaded', () => {
    const productGridContainer = document.querySelector('#ProductGridContainer');
    const filterContainer = document.querySelector('#FacetFiltersContainer');
    let filterCount = document.querySelector('.js-product-count');

    document.body.addEventListener('click', function (e) {
      const link = e.target.closest('[data-action="clear-filters"]');
      if (!link) return;
      
      const filterName = link.getAttribute('name');
      const filterValue = link.getAttribute('value');

      if (!filterName && !filterValue) {
        document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]:checked')
          .forEach((checkbox) => {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        let filterTabs = document.querySelectorAll('.js-filter-tab');
        filterTabs.forEach((tab) => {
            tab.classList.remove('active');
        });
      } else {
          const checkbox = document.querySelector(
            `input[name="${filterName}"][value="${filterValue}"]`
          );
          if (checkbox) {
            checkbox.checked = false;
            let filterType = checkbox.closest('.facets__disclosure')?.querySelector('.facets__summary-title').textContent.trim();
            // Find all checkboxes related to this filter type
            let relatedCheckboxes = checkbox.closest('.facets__disclosure')?.querySelectorAll('input[type="checkbox"]');
            if (relatedCheckboxes){
              let anyChecked = Array.from(relatedCheckboxes).some(checkbox => checkbox.checked);
              
              if (!anyChecked) {
                  let filterTabs = document.querySelectorAll('.js-filter-tab');
                  filterTabs.forEach((tab) => {
                      let tabContent = tab.textContent.trim();
                      if (tabContent === filterType) {
                          tab.classList.remove('active');
                      }
                  });
              }
            }
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
      }
      e.preventDefault();
      const url = link.getAttribute('href');

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const facetDetailsElements = doc.querySelectorAll(
            "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
          );

          const checkbox = document.querySelector(
            `input[name="${filterName}"][value="${filterValue}"]`
          );
          const matchesIndex = (element) => {
            const jsFilter = checkbox ? checkbox.closest(".js-filter") : undefined;
            return jsFilter
              ? element.dataset.index === jsFilter.dataset.index
              : false;
          };
          const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element)
          );
          facetsToRender.forEach((element) => {
            document.querySelector(
              `.js-filter[data-index="${element.dataset.index}"]`
            ).innerHTML = element.innerHTML;
          });
          const activeFacetElementSelectors = [
            ".active-facets-mobile",
            ".active-facets-desktop",
          ];

          activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = doc.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML =
              activeFacetsElement.innerHTML;
              toggleActiveFacets(false)
          });
          function toggleActiveFacets(disable = true) {
            document.querySelectorAll(".js-facet-remove").forEach((element) => {
              element.classList.toggle("disabled", disable);
            });
          }
          const newGrid = doc.querySelector('#ProductGridContainer');
          const newFilters = doc.querySelector('#FacetFiltersContainer');
          let resultCount = doc.querySelector('.js-product-count');

          if (newGrid && productGridContainer) {
            productGridContainer.innerHTML = newGrid.innerHTML;
          }

          if (newFilters && filterContainer) {
            filterContainer.innerHTML = newFilters.innerHTML;
          }

          if (filterCount && resultCount) {
            filterCount.innerHTML = resultCount.innerHTML;
          }

          history.pushState({}, '', url);
        });
    });
  });
}

{  
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('ContactForm');
    const checkboxes = form?.querySelectorAll('.js-contact-checkbox');
    const hiddenInput = document.getElementById('ContactForm-catalog-hidden');

    form?.addEventListener('submit', function (e) {
      const selectedValues = Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);
      hiddenInput.value = selectedValues.join(', ');
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelector(".js-search-input");

    if (!searchInput) return;

    
    searchInput.addEventListener("input", function () {
      const searchTerm = this.value.toLowerCase();
      
      document.querySelectorAll(".js-tab-main").forEach(tabBlock => {
        let visibleCount = 0;
        const noResultsDiv = tabBlock.querySelector(".js-no-results");
        tabBlock.querySelectorAll(".js-tab-item").forEach(item => {
          const titleElement = item.querySelector(".js-tab-item-title");

          if (titleElement) {
            const titleText = titleElement.textContent.toLowerCase();
            const skuText = titleElement.getAttribute("data-sku")?.toLowerCase() || "";
            const isMatch = titleText?.includes(searchTerm);
            const isSKU = skuText?.includes(searchTerm);

            if (titleText?.includes(searchTerm) || skuText?.includes(searchTerm)) {
              item.style.display = "block";
            } else {
              item.style.display = "none";
            }
            if (isMatch || isSKU) visibleCount++;
          }
        });
        if (noResultsDiv) {
          noResultsDiv.style.display = visibleCount === 0 ? "block" : "none";
        }
      });
    });
  });
}

// Multiple video download script
{
  document.querySelector('.js-video-download-btn')?.addEventListener('click', async function () {
    const checkboxes = document.querySelectorAll('.js-video-checkbox:checked');
    if (checkboxes.length === 0) {
      alert('Please select at least one video to download.');
      return;
    }

    const zip = new JSZip();
    const folder = zip.folder('videos');

    const fetchPromises = Array.from(checkboxes).map(async (checkbox, index) => {
      const videoCard = checkbox.closest('.multicolumn-card');
     const videoName =  videoCard.querySelector(".js-Video-text").textContent;
      let videoUrl = videoCard.querySelector('source').getAttribute('src');
      try {
        const response = await fetch(videoUrl);
        if (!response.ok) throw new Error(`Failed to fetch video ${index + 1}`);
        const blob = await response.blob();

        // Extract filename or generate one
        const urlParts = videoUrl.split('/');
        let filename = urlParts[urlParts.length - 1];
        if (!filename.endsWith('.mp4')) {
          filename = `${videoName}.mp4`;
        }

        folder.file(filename, blob);
      } catch (error) {
        console.error('Error downloading video:', videoUrl, error);
      }
    });

    try {
      await Promise.all(fetchPromises);
      const zipBlob = await zip.generateAsync({ type: 'blob' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(zipBlob);
      link.download = 'selected-videos.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('ZIP creation failed:', error);
      alert('An error occurred while creating the ZIP file.');
    }
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    function handleize(str) {
      return str
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }

    const button = document.querySelector(".js-rep-locator-button");
    const regionSelect = document.querySelector('select[name="region"]');
    const industrySelect = document.querySelector('select[name="industry"]');
    const regionError = document.getElementById("region-error");
    const industryError = document.getElementById("industry-error");
    const notAvailableText = document.querySelector(".js-not-available")

    regionSelect?.addEventListener("change", function () {
      if (regionSelect.value) regionError.classList.add("hidden");
    });

    industrySelect?.addEventListener("change", function () {
      if (industrySelect.value) industryError.classList.add("hidden");
    });

    button?.addEventListener("click", function () {
      const selectedRegion = handleize(regionSelect.value);
      const selectedIndustry = handleize(industrySelect.value);

      regionError.classList.add('hidden');
      industryError.classList.add('hidden');

      let hasError = false;
      if (!selectedRegion) {
        regionError.classList.remove('hidden');
        hasError = true;
      }
      if (!selectedIndustry) {
        industryError.classList.remove('hidden');
        hasError = true;
      }
      if (hasError) return;

      const cards = document.querySelectorAll(".js-multicolumn-card");
      const card_list = document.querySelector(".js-store-loctor-list");
      let count = 0;

      if (cards.length > 0) {
        cards.forEach(card => {
          // Check attribute based on industry selection
          const regionDataRaw = card.getAttribute(`data-${selectedIndustry}`) || "";
          const regionData = regionDataRaw.split(',').map(r => handleize(r));
          
          const hasRegion = regionData.includes(selectedRegion);

          if (hasRegion) {
            card.classList.remove("hidden");
            count++;
          } else {
            card.classList.add("hidden");
          }
        });

        if (count > 0) {
          card_list.classList.remove("hidden");
          notAvailableText.classList.add("hidden");
        } else {
          card_list.classList.add("hidden");
          notAvailableText.classList.remove("hidden");
        }

        const targetSection = document.querySelector(".js-rep-locator-wrapper");
        if (targetSection && count > 0) {
          targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });
}

// product care accordion
function openAccordion(accordionKey) {
  let accordion = document.querySelector(`.js-accordion-wrapper[data-accordion="${accordionKey}"]`);
  if (!accordion) return;

  let activeAccordion = document.querySelector('.js-accordion-wrapper.active');
  if (activeAccordion) {
    activeAccordion.classList.remove('active');
    activeAccordion.querySelector('.js-accordion-answer').style.display = 'none';
  }

  setTimeout(() => {
    if (accordionKey === 'business-terms-conditions') {
      let itemBottom = accordion.getBoundingClientRect().bottom;
      window.scrollTo({ behavior: 'smooth', top: itemBottom - window.innerHeight });
    } else {
      let itemTop = accordion.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ behavior: 'smooth', top: itemTop });
    }
  }, 500);

  accordion.classList.add('active');
  accordion.querySelector('.js-accordion-answer').style.display = 'block';
  slideDown(accordion.querySelector('.js-accordion-answer'), 300);
}

// Save state when clicking "more info" button in product page
document.querySelector('.js-btn-more-info')?.addEventListener('click', (event) => {
  let accordionText = event.currentTarget.getAttribute('data-anchor-link');
  sessionStorage.setItem('accordion-open', true);
  sessionStorage.setItem('accordion-data', accordionText);
});

// Terms of services(refund policy links) to terms and condition accordion

let refundLinks = document.querySelectorAll(".js-terms-services-links");

if (refundLinks.length > 0) {
  refundLinks.forEach( link => {
    link.addEventListener("click", ()=> {
      sessionStorage.setItem('accordion-open', true);
      sessionStorage.setItem('accordion-data', 'business-terms-conditions');
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  if (sessionStorage.getItem('accordion-open') === 'true') {
    let accordionKey = sessionStorage.getItem('accordion-data') || "where-to-buy";
    openAccordion(accordionKey);

    sessionStorage.removeItem('accordion-open');
    sessionStorage.removeItem('accordion-data');
  }
});

function slideDown(element, duration = 300) {
  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";
  element.style.display = display;

  let height = element.offsetHeight;
  element.style.height = 0;
  element.offsetHeight; // Force repaint
  element.style.transition = `height ${duration}ms ease`;
  element.style.height = height + "px";

  setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("transition");
  }, duration);
}


// Click item and scroll to the section For FAQs link
{
  document.querySelectorAll('.js-footer-item').forEach(item => {
    item.addEventListener('click',function(){
        sessionStorage.removeItem('page-scroll');
      if(item.getAttribute('data-link-title') != 'customer-service'){
        sessionStorage.setItem('page-scroll',true);
      }
    })
  })
}

function scrollToContainer(selector, attribute) {
  const scrollWrapper = document.querySelector(selector);
  if (!scrollWrapper) return;

  setTimeout(() => {
    const itemTop = scrollWrapper.getBoundingClientRect().top;
    window.scrollTo({ behavior: 'smooth', top: itemTop });
  }, 1400);
  sessionStorage.removeItem(attribute);
}


{
  document.querySelectorAll('.js-policy-item').forEach(item => {
    item.addEventListener('click',function(){
      if (item.href.includes('privacy-policy')) {
        sessionStorage.setItem('policy-page-scroll',true);
      }
    })
  })
}

{
  document.querySelectorAll('.js-card-scroll').forEach(item => {
    item.addEventListener('click',function(){
      sessionStorage.setItem('showroom-page-scroll',true);
    })
  })
}
document.addEventListener("DOMContentLoaded", function () {
  if (sessionStorage.getItem('page-scroll') === 'true') {
    scrollToContainer('.js-scroll-container','page-scroll');
    scrollToContainer('.js-showroom-scroll','page-scroll');
  }
  if (sessionStorage.getItem('policy-page-scroll') === 'true') {
    scrollToContainer('.cf-form-block','policy-page-scroll');
  }
  if (sessionStorage.getItem('showroom-page-scroll') === 'true') {
    scrollToContainer('.js-showroom-scroll','showroom-page-scroll');
  }
});


{
  document.addEventListener("DOMContentLoaded", () => {
    let imageJson = document.getElementById("image-sort");
    if (!imageJson) return;
    let data = JSON.parse(imageJson?.textContent);

    let select = document.getElementById("imageSort");
    let container = document.querySelector("image-gallery");
    if (!select || !container) return;

    function renderGallery(order) {
      container.innerHTML = data[order];
    }

    renderGallery(select.value);

    select?.addEventListener("change", (e) => {
      renderGallery(e.target.value);
    });
  });
}

/* Safari Browser Class Add JS */
{
  document.addEventListener("DOMContentLoaded", function() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1) {
      document.body.classList.add("safari-browser");
    }
  });
}

{
  document.querySelector(".js-close-button")?.addEventListener("click",()=>{
    document.querySelector(".b2b-login-message")?.classList.add("hidden");
  })
}

// Customer-service(where to buy) >> Tradeshow
{
  if (window.location.hash) {
    setTimeout(() => {      
      let scrollContainer = document.querySelector(".js-showroom-scroll");
      if (scrollContainer) {
        scrollContainer.scrollIntoView({ behavior: "smooth" });
      }
      history.replaceState(null, null, window.location.pathname + window.location.search);
    }, 1000);
  }
}

{
  document.addEventListener('DOMContentLoaded', () => {
    const customLoginBtn = document.querySelector('.js-custom-login-btn');
    
    if (customLoginBtn) {
      const params = new URLSearchParams(window.location.search);
      const returnTo = params.get('return_to');
      
      if (returnTo) {
        const url = new URL(customLoginBtn.href, window.location.origin);
        url.searchParams.set('return_to', returnTo);
        customLoginBtn.href = url.toString();
      }
    }
});
}

{
  let insertRadio = document.querySelectorAll(".js-insert-radio");
  let noInsertBtn = document.querySelector(".js-no-insert-click");
  let productPrice = document.querySelector(".js-insert-price-change");
  let basePrice = parseFloat(productPrice?.textContent.trim().replace(/[^0-9.]/g, '')) || 0;

  if (insertRadio.length > 0 && productPrice) {

    function updatePrice() {
      let selectedRadio = document.querySelector(".js-insert-radio:checked");
      let radioPrice = selectedRadio ? selectedRadio.getAttribute("data-variant-price") : null;
      let radioInt = radioPrice ? parseFloat(radioPrice.replace(/[^0-9.]/g, '')) : 0;

      let finalPrice = basePrice + radioInt;
      productPrice.textContent = `$${finalPrice.toFixed(2)}`;
    }

    insertRadio.forEach((radio) => {
      radio.addEventListener("click", updatePrice);
    });

    updatePrice();
  }
  if (noInsertBtn) {
    noInsertBtn.addEventListener("click",(e) => {
      if (productPrice) {
        productPrice.textContent = `$${basePrice.toFixed(2)}`;
      }
    })
  }
}

{
  {
    const tradeBtns = document.querySelectorAll(".js-trade-scroll-btn");
    const tradeBlocks = document.querySelectorAll(".js-scroll-trade-block");

    if (tradeBtns.length > 0) {
      tradeBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          sessionStorage.setItem("trade-scroll", true);
          if (tradeBlocks.length > 0) {
            tradeBlocks[0].scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      });
    }
  }
}

{
  const accordionItems = document.querySelectorAll(".js-package-accordion-item");
  if (accordionItems.length > 0) {
    accordionItems.forEach((item) => {
      const header = item.querySelector(".js-accordion-btn");
      header.addEventListener("click", () => {
        item.classList.toggle("open");
      });
    });
  }
}